module.exports = __webpack_public_path__ + "static/media/XAVA.e48d4100.png";